import { useQuery, UseQueryOptions, UseQueryResult } from "react-query"
import { QueryKeys } from "./_query_keys"
import { HttpRequest } from "services/_http"
import { APIEndpoints } from "constants/api-endpoints"
import { AxiosResponse } from "axios"

interface DashboardParams {
  month: number
  year: number
}

export interface DashboardTopEpisode {
  id: string
  name: string
  views: number
  duration: number
  thumbnail: string
  creator: string
}

export interface DashboardComprehensiveResult {
  userStats: {
    totalUsers: number
    paidUsers: number
    trialUsers: number
    freeUsers: number
    ottUsers: number
  }
  contentStats: {
    totalCategories: number
    totalEpisodes: number
    totalShows: number
    totalCollections: number
  }
  topEpisodes: DashboardTopEpisode[]
}

export interface DashboardComprehensiveResponse {
  results: DashboardComprehensiveResult
  pages: unknown
  total: number
  pagination: unknown
  message: string
}

export const useGetDashboardReport = (
  params: DashboardParams,
  options?: UseQueryOptions<AxiosResponse<DashboardComprehensiveResponse>>
): UseQueryResult<AxiosResponse<DashboardComprehensiveResponse>> => {
  const method = "GET"

  return useQuery({
    queryKey: [QueryKeys.DASHBOARD_REPORT, params.month, params.year],

    queryFn: () =>
      HttpRequest({
        url: APIEndpoints.DashboardComprehensive,
        method,
        params: {
          Month: params.month,
          year: params.year,
        },
      }),

    refetchOnWindowFocus: false,
    cacheTime: 0,

    ...options,
  })
}